import { getAllCursos, getAllCursosEstudante } from "./Api";
import { useCursosStorage } from "./storage/cursos";
import { useUserStorage } from "./storage/user";
import Cookies from "js-cookie";


export const getEscolaridadeById = (id) => {
    if (typeof id !== "number") return null; // Verifica se a entrada é um número

    const escolaridade = escolaridadeAll.find(item => item.id === id);

    return escolaridade ? escolaridade.name : null; // Retorna o nome ou null se não encontrar
};

export const escolaridadeAll = [
    {
        "value": "FUNDAMENTAL_COMPLETO",
        "name": "Fundamental",
        "id": 1,
    },
    {
        "value": "MEDIO_COMPLETO",
        "name": "Médio",
        "id": 3,
    },
    {
        "value": "TECNICO_COMPLETO",
        "name": "Técnico",
        "id": 12
    },
    {
        "value": "SUPERIOR_COMPLETO",
        "name": "Superior",
        "id": 5
    },
    {
        "value": "POS_GRADUACAO_COMPLETO",
        "name": "Pós-graduação",
        "id": 7
    },
    {
        "value": "MESTRADO_COMPLETO",
        "name": "Mestrado",
        "id": 9
    },
    {
        "value": "DOUTORADO_COMPLETO",
        "name": "Doutorado",
        "id": 11
    },
]

export const escolaridadeAllBack = {
    FUNDAMENTAL_COMPLETO: "Fundamental",
    MEDIO_COMPLETO: "Médio",
    TECNICO_COMPLETO: "Técnico",
    SUPERIOR_COMPLETO: "Superior",
    POS_GRADUACAO_COMPLETO: "Pós-graduação",
    MESTRADO_COMPLETO: "Mestrado",
    DOUTORADO_COMPLETO: "Doutorado",
}


export default function linkEmbed(link) {
    if (!link) return
    function getId(url) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = url.match(regExp);

        if (match && match[2].length == 11) {
            return match[2];
        } else {
            return 'error';
        }
    }

    var myId = getId(link);
    return `//www.youtube.com/embed/${myId}`
}

export function getAllCursosMatriculados() {

    const { setCursosDoEstudante } = useCursosStorage.getState().dispatch
    if (localStorage.getItem("tipo") == 'ALUNO' || localStorage.getItem("tipo") == 'ESTUDANTE') {
        
        getAllCursosEstudante({ id: localStorage.getItem("id") }).then(response => {
            if (response) {

                /*  const stringObjCursos = JSON.stringify(response.data);
                localStorage.setItem("cursosEstudante", stringObjCursos); */
                setCursosDoEstudante(response.data)

                return response.data
            }

        })
    }

}
export function getAllCursosTotais() {

    const { setCursosTotais } = useCursosStorage.getState().dispatch
    getAllCursos().then(res => {
        setCursosTotais(res.data)
    })

}

export function formatDateToDDMMYYYY(dateString) {
    // Divide a data no formato "YYYY-MM-DD" em partes separadas
    const [year, month, day] = dateString.split('-');
    // Retorna a data no formato "DD/MM/YYYY"
    return `${day}/${month}/${year}`;
}

export function AtualizarDataCursos() {

    const { dispatch } = useUserStorage.getState()


    const { cursosEstudante, cursos } = useUserStorage.getState()

    if (cursos?.length === 0) {
        getAllCursos().then(res => {
            const stringObjCursos = JSON.stringify(res.data);
            localStorage.setItem("cursos", stringObjCursos);
            dispatch.setCursos(res.data)

            if (cursosEstudante?.length === 0) {
                //matriculados
                if (localStorage.getItem("tipo") == 'ALUNO' || localStorage.getItem("tipo") == 'ESTUDANTE') {


                    getAllCursosEstudante({ id: localStorage.getItem("id") }).then(response => {
                        const stringObjCursos = JSON.stringify(response.data);
                        localStorage.setItem("cursosEstudante", stringObjCursos);



                        if (response.data === '') {
                        } else {
                            const { cursos } = useUserStorage.getState()
                            var idsMatriculados = []

                            var addStatusCursosMatriculados = []
                            response.data.map(item => {
                                idsMatriculados.push(item.id)

                                var complete = true

                                item?.modulos.map(value => {
                                    value?.aulas.map(asd => {
                                        if (asd?.assistido === false) {
                                            complete = false
                                        }
                                    })
                                })

                                addStatusCursosMatriculados.push({ ...item, complete })

                            })
                            var newCursos = []
                            cursos.map(item => {
                                if (!idsMatriculados.includes(item.id)) {
                                    newCursos.push(item)
                                }
                            })
                            dispatch.setCursos(newCursos)



                            dispatch.setCursosEstudante(addStatusCursosMatriculados)

                        }

                    })
                }
            }

        })
    }






    /* const cursos = localStorage.getItem("cursosEstudante");
    dispatch.setCursosEstudante(JSON.parse(cursos)) */


}

export function capitalizeInitials(text) {
    return text
        .toLowerCase() // Converte todo o texto para minúsculas
        .split(' ') // Divide o texto em palavras
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Converte a inicial para maiúscula
        .join(' '); // Junta as palavras novamente em uma string
}

export function removeAllLocalStorage() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("tipo");
    localStorage.removeItem("nome");
    localStorage.removeItem("user_id");
    localStorage.removeItem("temCarteira");
    localStorage.removeItem("id");

    Cookies.remove('login') 
}

export function isCarteirinhaValida(dataString) {
    if(dataString == undefined){
        return false
    }
  // Converte "31/03/2025" em um objeto Date
  const [dia, mes, ano] = dataString.split('/');
  const dataLimite = new Date(ano, mes - 1, dia); // JS: mês começa do 0

  // Pega a data atual sem horário
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0); // remove hora, minuto, segundo e milissegundo

  // Compara
  return hoje <= dataLimite;
}